import React from 'react';
import { Box } from '@mui/material';
import Autocomplete from '@mui/material/Autocomplete';
import { CssTextField } from 'components/select';
import { useMutation } from 'react-query';
import axios, { endPoints } from 'api/request';
import throttle from 'lodash/throttle';
import { useRecoilState } from 'recoil';
import SearchIcon from '@mui/icons-material/Search';
import { orderPayload, isValidOwners, certCreationRequired, customDomainFieldsDiasbled } from 'pages/provisioning/virtual-service/store';
import { isUniqueOwner } from 'pages/provisioning/virtual-service/utils';
import InfoImg from 'components/info-img';
import ProvisioningStyles from 'pages/provisioning/virtual-service/style';

const CertificateOwnerTwo = () => {
    const [isTouched, setIsTouched] = React.useState(false);
    const [order, setOrder] = useRecoilState(orderPayload);
    const [validOwner, setValidOwner] = useRecoilState(isValidOwners);
    const [value, setValue] = React.useState(null);
    const [ccInputValue, setCCInputValue] = React.useState('-');
    const [searched, setSearched] = React.useState(false);
    const [options, setOptions] = React.useState([]);
    const [isRequired] = useRecoilState(certCreationRequired);
    const [isDisabled] = useRecoilState(customDomainFieldsDiasbled);

    const appOwnerApi = useMutation(() => axios.get(`${endPoints.virtualService.applicationOwner}?key=${ccInputValue}`));
    const appOwnerPostApi = useMutation((payload) => axios.get(`${endPoints.virtualService.applicationOwner}?key=${payload}`));

    const setCertificateOwnerTwo = (certificateOwnerTwo, certificateOwnerTwoDetails) => {
        setOrder({
            ...order,
            certificateOwnerTwo,
            certificateOwnerTwoDetails,
        });
    };

    React.useEffect(() => {
        if (!order?.certificateOwnerTwo && !order?.certificateOwnerTwoDetails) {
            setOptions([]);
        }
    }, [order?.certificateOwnerTwo, order?.certificateOwnerTwoDetails]);

    const resetOptions = () => {
        setOptions([]);
        setCertificateOwnerTwo(null, null);
    };
    const fetch = React.useMemo(
        () =>
            throttle(() => {
                appOwnerApi.mutate();
            }, 1000),
        []
    );
    const handleSearch = () => {
        // istanbul ignore if
        if (ccInputValue === '') {
            resetOptions();
        }
        // istanbul ignore else
        if (ccInputValue !== '' && ccInputValue.length > 2) {
            setSearched(true);
            fetch();
        }
    };
    const isExistsInOptions = (appownerValue) => options.find((option) => appownerValue === option.name);

    React.useEffect(() => {
        if (options && options?.length === 1 && !order?.certificateOwnerTwo && order?.certificateOwnerTwoDetails) {
            setOrder({ ...order, certificateOwnerTwo: options?.[0].label, certificateOwnerTwoDetails: options?.[0] });
        }
        if (options && options?.length > 1 && order?.certificateOwnerTwoDetails && !order?.certificateOwnerTwo) {
            const appOwerObj = isExistsInOptions(order?.certificateOwnerTwo?.name);
            setOrder({ ...order, certificateOwnerTwo: appOwerObj?.label, certificateOwnerTwoDetails: appOwerObj });
        }
    }, [options]);
    React.useEffect(() => {
        if (appOwnerApi?.data?.data) {
            const combinedValue = appOwnerApi?.data?.data?.map((app) => ({
                label: `${app.gpid} - ${app.name}`,
                gpid: `${app.gpid}`,
                name: `${app.name}`,
                email: `${app.email}`,
            }));
            setOptions(combinedValue);
        }
    }, [appOwnerApi?.data?.data]);

    React.useEffect(() => {
        if (appOwnerPostApi?.data?.data) {
            const combinedValue = appOwnerPostApi?.data?.data?.map((app) => ({
                label: `${app.gpid} - ${app.name}`,
                gpid: `${app.gpid}`,
                name: `${app.name}`,
                email: `${app.email}`,
            }));
            setOptions(combinedValue);
        }
    }, [appOwnerPostApi?.data?.data]);

    React.useEffect(() => {
        if (value === null) {
            // resetOptions();
        } else {
            setOptions(options?.filter((z) => z?.gpid === value?.gpid));
            setCertificateOwnerTwo(value?.label, value);
        }
    }, [value]);

    React.useEffect(() => {
        if (!order?.certificateOwnerTwo && order?.certificateOwnerTwoDetails) {
            appOwnerPostApi.mutate(order?.certificateOwnerTwoDetails?.gpid);
        }
        if (!order?.certificateOwnerTwo && !order?.certificateOwnerTwoDetails) {
            setOptions([]);
        }
    }, [order?.certificateOwnerTwo, order?.certificateOwnerTwoDetails]);

    React.useEffect(() => {
        if (!order?.certificateOwnerTwo && order?.isTouched) setIsTouched(true);
        else setIsTouched(false);
    }, [order?.certificateOwnerTwo, order?.isTouched]);

    const validateInput = () => {
        let validateText = '';
        if ((isTouched && order?.isTouched && !order?.certificateOwnerTwo) || isTouched || validOwner?.isValidCertificateOwnerTwo === false) {
            validateText = 'validate';
        } else if (isRequired && !order?.certificateOwnerTwo) {
            validateText = 'validate1';
        }
        return validateText;
    };
    const getNoOptionText = () => {
        let text = '';
        if (searched === false) {
            text = 'Type & press enter to search by GPID, Firstname and Lastname';
        } else if (options?.length === 0) {
            text = 'No results found';
        }
        return text;
    };
    React.useEffect(() => {
        if (order?.certificateOwnerTwo) {
            const checkValidOwner = isUniqueOwner(order?.certificateOwnerTwo, [order?.certificateOwnerOne, order?.applicationOwner]);
            if (!checkValidOwner) {
                setValidOwner({ ...validOwner, isValidCertificateOwnerTwo: false });
            } else {
                setValidOwner({ ...validOwner, isValidCertificateOwnerTwo: true });
            }
        }
    }, [order?.certificateOwnerTwo]);
    return (
        <>
            <Box display="flex" alignItems="center" gap={1} data-testid="cert-owner-two">
                <Autocomplete
                    key="cert2OwnerDetails"
                    size="small"
                    noOptionsText={getNoOptionText()}
                    loading={appOwnerApi?.isLoading}
                    disabled={!isRequired || isDisabled}
                    value={order?.certificateOwnerTwo || null}
                    onInputChange={(event, newInputValue) => {
                        if (newInputValue) setCCInputValue(newInputValue?.includes('-') ? newInputValue?.split('-')?.pop()?.trim() : newInputValue);
                    }}
                    onChange={(event, newValue) => {
                        // istanbul ignore else
                        if (typeof newValue === 'string') {
                            setValue({
                                label: newValue,
                            });
                        } else if (newValue && newValue.inputValue) {
                            // Create a new value from the user input
                            setValue({
                                label: newValue.inputValue,
                            });
                        } else {
                            setValue(newValue);
                        }
                    }}
                    filterOptions={(optionValues, params) => {
                        // eslint-disable-next-line no-underscore-dangle
                        const _results = [];
                        // eslint-disable-next-line no-plusplus
                        for (let i = 0; i < optionValues.length; i++) {
                            // eslint-disable-next-line no-restricted-syntax
                            for (const key in optionValues[i]) {
                                if (optionValues[i][key] !== null && typeof optionValues[i][key] !== 'boolean' && typeof optionValues[i][key] !== 'number') {
                                    if (optionValues[i][key].toLowerCase().includes(params?.inputValue.toLowerCase())) {
                                        _results.push(optionValues[i]);
                                    }
                                }
                            }
                        }
                        return [...new Set(_results)];
                    }}
                    selectOnFocus
                    clearOnBlur
                    handleHomeEndKeys
                    disableClearable
                    id="free-solo-with-text-demo"
                    options={options}
                    isOptionEqualToValue={(option, value1) => option?.label === value1}
                    sx={{ width: '100%' }}
                    onBlur={() => {
                        if (!value || !order?.certificateOwnerTwo) {
                            setSearched(false);
                            setOptions([]);
                            setValidOwner({ ...validOwner, isValidCertificateOwnerTwo: true });
                        }
                    }}
                    onKeyUp={(event) => {
                        if (event.key === 'Enter') {
                            setSearched(true);
                            handleSearch();
                        }
                        if ((event.key === 'Backspace' || event.key === 'Delete') && (!event.target.value || event.target.value === '')) {
                            setSearched(false);
                            resetOptions();
                            setValidOwner({ ...validOwner, isValidCertificateOwnerTwo: true });
                        }
                    }}
                    className={validateInput()}
                    renderInput={(params) => (
                        <CssTextField
                            size="large"
                            error={validOwner?.isValidCertificateOwnerTwo === false}
                            helperText={validOwner?.isValidCertificateOwnerTwo === false && <span>Please choose different member</span>}
                            className={validateInput()}
                            // eslint-disable-next-line react/jsx-props-no-spreading
                            {...params}
                            label="Certificate Owner 2 *"
                            InputProps={{
                                ...params.InputProps,
                                endAdornment: (
                                    <>
                                        <SearchIcon
                                            sx={ProvisioningStyles?.searchIcon}
                                            onClick={() => {
                                                setSearched(true);
                                                handleSearch();
                                            }}
                                            data-testid="search-btn"
                                        />
                                    </>
                                ),
                            }}
                            fullWidth
                            data-testid="Cert2Search"
                        />
                    )}
                />
                <InfoImg title="Certificate Owner Two is required only if there is a need for certificate creation for given custom domain." />
            </Box>
        </>
    );
};

export default React.memo(CertificateOwnerTwo);
